export const environment = {
  production: true,
  connection: {
    name: 'LH Axams Softline',
    host: 'https://softline.axamer.at/',
    port: 443,
    basePath: '/restapi/api'
  },
  androidUpdateRepository: ''
};
